export const EWorkspaceCreditTransactonType = {
  RECHARGE_PERSONAL_CREDITS: 'recharge_personal_credits',
  DIFFUSION_MODEL_RENT: 'diffusion_model_rent',
  GENERATE_IMAGE: 'generate_image',
  IMAGE_TO_TEXT: 'image_to_text',
  WORD_GET_RELATED_WORDS: 'word_get_related_words',
  WORD_GET_RELATED_WORDS_FAILED: 'word_get_related_words_failed',
  VOTE_FOR_DIFFUSION_MODEL: 'vote_for_diffusion_model',
};
